import React from 'react'
import { GoogleMap, withGoogleMap } from 'react-google-maps'

import { Wrap } from './styles'

export const toodoCoords = {
  lat: -26.9216134,
  lng: -49.0647538
}

const MapContainer = withGoogleMap(
  ({
    googleMapURL,
    loadingElement,
    containerElement,
    children,
    ...props
  }: any) => <GoogleMap {...props}>{children}</GoogleMap>
)

MapContainer.defaultProps = {
  defaultZoom: 8,
  defaultCenter: toodoCoords,
  containerElement: <Wrap />,
  mapElement: <div style={{ height: '100%' }} />
}

export default MapContainer
